import label from './tooltip.axisPointer.label'
import lineStyle from './tooltip.axisPointer.lineStyle'
import shadowStyle from './tooltip.axisPointer.shadowStyle'
import crossStyle from './tooltip.axisPointer.crossStyle'

export default {
  name: "axisPointer",
  nickname: "坐标轴指示器",
  desc: "坐标轴指示器配置项。",
  type: "object",
  props: {
    type: {
      name: "type",
      nickname: "类型",
      desc: "指示器类型。",
      value: "line",
      defaultValue: "line",
      type: "pureValue",
    },
    axis: {
      name: "axis",
      nickname: "坐标轴",
      desc: "指示器的坐标轴。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    snap: {
      name: "snap",
      nickname: "snap",
      desc: "坐标轴指示器是否自动吸附到点上。默认自动判断。",
    },
    z: {
      name: "z",
      nickname: "z",
      desc:
        '坐标轴指示器的 z 值。控制图形的前后顺序。<code class="codespan">z</code>值小的图形会被<code class="codespan">z</code>值大的图形覆盖。',
    },
    label,
    lineStyle,
    shadowStyle,
    crossStyle,
    animation: {
      name: "animation",
      nickname: "是否使用动画",
      desc: "是否开启动画。",
      value: true,
      defaultValue: true,
      type: "pureValue",
    },
    animationThreshold: {
      name: "animationThreshold",
      nickname: "是否开启动画的阈值",
      desc:
        "是否开启动画的阈值，当单个系列显示的图形数量大于这个阈值时会关闭动画。",
      value: 2000,
      defaultValue: 2000,
      type: "pureValue",
    },
    animationDuration: {
      name: "animationDuration",
      nickname: "动画时长",
      desc:
        "初始动画的时长，支持回调函数，可以通过每个数据返回不同的时长实现更戏剧的初始动画效果：",
      value: 1000,
      defaultValue: 1000,
      type: "pureValue",
    },
    animationEasing: {
      name: "animationEasing",
      nickname: "初始动画缓动效果",
      desc:
        '初始动画的缓动效果。不同的缓动效果可以参考 <a href="https://echarts.apache.org/examples/zh/editor.html?c=line-easing" target="_blank">缓动示例</a>。',
      value: "cubicOut",
      defaultValue: "cubicOut",
      type: "pureValue",
    },
    animationDelay: {
      name: "animationDelay",
      nickname: "初始动画延迟",
      desc:
        "初始动画的延迟，支持回调函数，可以通过每个数据返回不同的 delay 时间实现更戏剧的初始动画效果。",
      value: 0,
      defaultValue: 0,
    },
    animationDurationUpdate: {
      name: "animationDurationUpdate",
      nickname: "动画时长",
      desc: "数据更新动画的时长。",
      value: 200,
      defaultValue: 200,
      type: "pureValue",
    },
    animationEasingUpdate: {
      name: "animationEasingUpdate",
      nickname: "数据更新动画的缓动效",
      desc: "数据更新动画的缓动效果。",
      value: "exponentialOut",
      defaultValue: "exponentialOut",
      type: "pureValue",
    },
    animationDelayUpdate: {
      name: "animationDelayUpdate",
      nickname: "数据更新动画的延迟",
      desc:
        "数据更新动画的延迟，支持回调函数，可以通过每个数据返回不同的 delay 时间实现更戏剧的更新动画效果。",
      value: 0,
      defaultValue: 0,
    },
  },
}
